import styled from "styled-components";
import {Checkbox, Typography} from "@material-ui/core";

export const AppInfoContainer = styled.div`
  margin-top: 20px;
`;

export const DetailTitle = styled(Typography)`
  padding-bottom: 5px;
  font-weight: 600 !important;
`;

export const DetailValue = styled(Typography)`
  padding: 5px 0;
  white-space: nowrap;
  align-self: flex-start;
  font-size: 0.9rem !important;
`;

export const DetailsValueItalic = styled(DetailValue)`
  font-style: italic;
`;

export const StyledCheckbox = styled(Checkbox).attrs({
    color: 'default',
})`
  padding: 0;
  margin: 0 10px;
  border-width: 1.5px !important;
`;